import React, { useEffect, useState } from 'react';
import BackToTop from '../../components/elements/BackToTop';
import Header from '../../components/Layout/Header';
import navImg1 from '../../assets/images/resources/logo-1.png';
import FooterTwo from '../../components/Layout/Footer/FooterStyleTwo';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import bannerbg from '../../assets/images/backgrounds/breadcrumb-1-1-1.webp';
import CtaTwo from '../../components/Common/CtaSection/CtaTwo';
import ServicesMain from './ServicesMain';
import TestimonialTwo from '../home-2/TestimonialTwo';
import { Helmet } from 'react-helmet';


// Breadcrumbs Background Image

const Services = () => {

    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <React.Fragment>
             <Helmet>
                <title>Careers- techtotalers</title>
            </Helmet>
        <Header
            navImg={navImg1}
            parentMenu='services'
            activeMenu="/careers"
        />
        {/* SiteBreadcrumb */}
        <SiteBreadcrumb
            pageTitle="Careers"
            pageName="Careers"
            breadcrumbsImg={bannerbg}
        />
        {/* SiteBreadcrumb */}
        <ServicesMain/>
        {/*cta-section */}
          
        <CtaTwo/>
        
        {/*cta-section end */}
        <BackToTop scroll={isVisible} />
        
        <FooterTwo />
    </React.Fragment>
    );
}

export default Services;